import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsStandUpPaddlingNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M18 11h-4V9h4zM14 14h4v-2h-4zM17 17h-2v-2h2z" />
        <path d="M15.628.07a1.07 1.07 0 01.744 0c.339.125 1.52.66 2.607 2.308 1.083 1.643 2.02 4.313 2.02 8.622 0 7.455-2.762 11.934-3.134 12.505a1.093 1.093 0 01-.918.495h-1.894c-.335 0-.697-.156-.918-.495C13.762 22.935 11 18.455 11 11c0-4.309.938-6.98 2.021-8.622C14.108.73 15.289.195 15.628.071zM16 2.118c-.31.2-.809.603-1.31 1.362C13.875 4.718 13 6.98 13 11c0 5.908 1.86 9.758 2.562 11h.875C17.14 20.759 19 16.908 19 11c0-4.02-.874-6.28-1.691-7.52-.5-.759-.998-1.163-1.31-1.362zM2.989 21.515c.952.347 1.794.21 2.35.016.772-.268 1.172-.923 1.36-1.438l.453-1.244a6 6 0 00-.2-4.588l-.15-.318 3.991-10.964.94.342.684-1.88L8.658.073l-.684 1.88.94.342L4.919 13.27l-.303.141a6 6 0 00-3.103 3.386l-.452 1.244c-.188.515-.302 1.274.117 1.975a3.474 3.474 0 001.81 1.5zm1.721-1.901a.152.152 0 01-.03.028c-.249.087-.6.142-1.007-.006a1.475 1.475 0 01-.777-.643.148.148 0 01-.004-.041c0-.048.011-.126.048-.227l.453-1.244a4 4 0 011.844-2.144 4 4 0 01.035 2.828L4.82 19.41a.688.688 0 01-.11.205z" />
      </g>
    </svg>
  )
);
SvgSportsStandUpPaddlingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsStandUpPaddlingNormalSmall;
